/*
  CRO colour grouping - the colour row on MONICA and JUDE product pages.
  Approved 24 Sep 2026 (2 hrs, $40). Trello: https://trello.com/c/zpp8Po6U

  The client asked whether the colours on these product pages could be hidden and replaced with a
  banner through to the picker page. That was recommended against and she agreed: the MONICA
  (white) page carries 47 links to its other colours, and those links are how Google reaches and
  ranks each colour page.

  So nothing is removed here. The theme's own colour list - div.attribute-product, a grid of 47
  photo thumbnails 620px tall on a phone - is restyled into the same single scrolling row of
  colour swatches used on the collection cards. Same anchors, same hrefs, same number of links;
  only the presentation changes. The picker link goes underneath.

  Colours come from the live endpoint (templates/search.cro-colours.liquid), so a new colour
  appears here on its own, exactly as it does on the collection pages.

  If anything fails, the theme's own thumbnail grid is left exactly as it was.
*/
(function () {
  var PICKER_URL = '/pages/headpiece-colour-picker';
  var PICKER_STYLES = ['MONICA', 'JUDE'];
  var MAX_PAGES = 6;

  /* Whether the swatches are hidden on MONICA and JUDE, leaving the picker link.

     Read from the page rather than set here: snippets/cro-pdp-colours.liquid holds the switch,
     because its stylesheet has to know the same answer before anything paints. One switch, one
     place - it used to be a var here as well, which is two things to keep in step. */
  var HIDE_ON_PDP = false;

  /* The block is held blank at its finished size until the row is built - see the snippet. Every
     way out of this file clears it, including the ones that leave the theme's own grid alone,
     because a block that is never shown is worse than one that changes. */
  function done() {
    document.documentElement.classList.remove('cro-pdp-pending');
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function handleOf(a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // data-p is the product title, e.g. "MONICA (azure)".
  function styleFrom(wrap) {
    var any = wrap.querySelector('.p_data_item[data-p]');
    if (!any) return null;
    var t = any.getAttribute('data-p') || '';
    var m = t.match(/^(.*?)\s*\(/);
    return m ? m[1].trim().toUpperCase() : null;
  }

  function fetchStyle(style) {
    var key = 'cro_live_' + style;
    try {
      var cached = sessionStorage.getItem(key);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) {}

    var all = [];
    function page(n) {
      var qs = 'q=' + encodeURIComponent('title:"' + style + '"') +
               '&type=product&view=cro-colours&page=' + n;
      return fetch('/search?' + qs, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.items) return null;
          all = all.concat(d.items);
          if (n < d.pages && n < MAX_PAGES) return page(n + 1);
          return all;
        });
    }
    return page(1).then(function (items) {
      if (!items) return null;
      var head = style + ' (';
      var mine = items.filter(function (it) {
        return String(it.n || '').toUpperCase().indexOf(head) === 0;
      });
      try { sessionStorage.setItem(key, JSON.stringify(mine)); } catch (e) {}
      return mine;
    }).catch(function () { return null; });
  }

  /* Same rules as the collection cards: one colour fills the circle, two split it on the
     diagonal, and a print with no colour of its own keeps a close-up of its own photo - which is
     already sitting in the anchor as the thumbnail the theme rendered. */
  function paint(dot, colour, fallbackImg) {
    var cols = (colour && colour.c) || [];
    // Polka: the base colour with white spots drawn over it, same as the collection cards.
    if (colour && colour.pt === 'polka' && cols.length) {
      dot.style.backgroundColor = cols[0];
      // Four spots, placed rather than tiled - tiling read as noise at this size.
      dot.style.backgroundImage =
        'radial-gradient(circle at 31% 29%, #fff 10%, transparent 11%),' +
        'radial-gradient(circle at 71% 33%, #fff 10%, transparent 11%),' +
        'radial-gradient(circle at 29% 70%, #fff 10%, transparent 11%),' +
        'radial-gradient(circle at 69% 72%, #fff 10%, transparent 11%)';
      dot.style.backgroundSize = '100% 100%';
      dot.style.backgroundRepeat = 'no-repeat';
      return;
    }
    if (cols.length > 1) {
      dot.style.backgroundImage = 'linear-gradient(135deg, ' + cols[0] + ' 50%, ' + cols[1] + ' 50%)';
      dot.style.backgroundSize = '100% 100%';
    } else if (cols.length === 1) {
      dot.style.backgroundColor = cols[0];
    } else if (fallbackImg) {
      dot.style.backgroundImage = 'url("' + fallbackImg + '")';
    }
  }

  var CHEVRON = '<svg width="7" height="12" viewBox="0 0 7 12" aria-hidden="true" focusable="false">' +
                '<path d="M1 1l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';

  function arrow(dir, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cro-sw__arrow cro-sw__arrow--' + dir;
    b.setAttribute('aria-label', label);
    b.innerHTML = CHEVRON;
    return b;
  }

  function slide(track, dir) {
    track.scrollBy({ left: dir * Math.max(80, track.clientWidth * 0.8), behavior: 'smooth' });
  }

  function syncArrows(wrap, track) {
    var over = track.scrollWidth - track.clientWidth;
    wrap.classList.toggle('cro-sw--scroll', over > 2);
    var prev = wrap.querySelector('.cro-sw__arrow--prev');
    var next = wrap.querySelector('.cro-sw__arrow--next');
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft >= over - 1;
  }

  function makeDot(handle, data) {
    var a = document.createElement('a');
    a.className = 'p_data_item';
    a.setAttribute('href', '/products/' + handle);
    if (data && data.n) a.setAttribute('data-p', data.n);
    return a;
  }

  /* The theme's own list is not always the whole style: the JUDE page listed 34 of its 103
     colours, so the product page disagreed with the collection card. The row is built from the
     live list instead, reusing the theme's anchor for a colour wherever it already has one and
     adding a plain link for the rest. That keeps every existing link and adds the missing ones,
     which is more of what this card set out to protect, not less. */
  function orderedAnchors(wrap, byHandle) {
    var existing = {};
    [].slice.call(wrap.querySelectorAll('.p_data_item')).forEach(function (a) {
      var h = handleOf(a);
      if (h) existing[h] = a;
    });

    var live = Object.keys(byHandle).map(function (h) { return byHandle[h]; })
      .filter(function (it) { return it && it.h; })
      .sort(function (a, b) {
        var al = (a.l || a.n || '').toLowerCase(), bl = (b.l || b.n || '').toLowerCase();
        return al < bl ? -1 : al > bl ? 1 : 0;
      });

    var out = [];
    live.forEach(function (it) {
      out.push(existing[it.h] || makeDot(it.h, it));
    });

    /* A colour the theme links that the live read did not return is left out on purpose. The
       live read is the storefront's own search, so it only returns products that are actually
       published and listed - which is exactly the set a customer can reach.

       On the MONICA page the two left out were:
         monica-headband-lime            Active, 7 in stock, but /products/monica-headband-lime
                                         answers 404 - not published to the online store. The
                                         theme was linking customers to a dead page.
         monica-headband-spiced-pumpkin  Unlisted, so deliberately kept out of listings.
       Neither should be a swatch. Both are worth the client knowing about, and the lime one is
       lost sales rather than a display problem. */
    return out;
  }

  /* With the swatches hidden, MONICA and JUDE still carried two leftovers above the picker link:
     the theme's variant box ("Color: White" with a single boxed option) and the colour label
     ("Colour: white"). Chantelle, 12 Oct 2026: "can we remove please? and just leave the link."

     Only on the styles whose swatches are hidden. Jordianne in the same thread: "we still want to
     keep the colour names on other products though", so nothing here is site-wide.

     Hidden, not removed. The variant box holds the form input the Add to cart button posts, and
     deleting it would break adding to cart on a one-variant product. */
  function hideColourLabels() {
    // Searched across the page rather than inside the colour list's own form: the variant box and
    // the label are not inside it, and scoping to it hid neither. Safe to go this wide because
    // this only ever runs on a product page, and only for a style whose swatches are hidden.

    // The theme's own variant picker. One colour per product here, so the box offers no choice.
    [].slice.call(document.querySelectorAll('variant-radios, variant-selects')).forEach(function (el) {
      el.style.display = 'none';
    });

    // "Colour: white" - the label the theme prints above the colour list.
    [].slice.call(document.querySelectorAll('.label-option')).forEach(function (el) {
      if (/^colou?r\s*:/i.test((el.textContent || '').trim())) el.style.display = 'none';
    });
  }

  function build(wrap, byHandle, style) {
    var items = orderedAnchors(wrap, byHandle);
    if (items.length < 2) return;

    var row = document.createElement('div');
    row.className = 'cro-sw cro-sw--pdp';
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', 'Colours available');

    var track = document.createElement('div');
    track.className = 'cro-sw__track';

    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    var here = m ? m[1] : null;

    items.forEach(function (a) {
      var h = handleOf(a);
      var data = h ? byHandle[h] : null;
      var img = a.querySelector('img');
      var src = img ? img.getAttribute('src') : ((data && data.i) || null);
      var label = (a.getAttribute('data-p') || '').replace(/^.*\(|\)\s*$/g, '').trim();

      // The anchor itself becomes the swatch, so the link and its href survive untouched.
      a.classList.add('cro-sw__dot');
      a.innerHTML = '';
      a.setAttribute('title', a.getAttribute('data-p') || label);
      a.setAttribute('aria-label', a.getAttribute('data-p') || label);
      // The theme marks the current colour with .active; an anchor added here has to work it out
      // from the address instead.
      if (h && here && h === here) a.classList.add('active');
      if (a.classList.contains('active')) a.setAttribute('aria-current', 'true');
      paint(a, data, src);
      track.appendChild(a);
    });

    var prev = arrow('prev', 'Previous colours');
    var next = arrow('next', 'More colours');
    prev.addEventListener('click', function (e) { e.preventDefault(); slide(track, -1); });
    next.addEventListener('click', function (e) { e.preventDefault(); slide(track, 1); });
    track.addEventListener('scroll', function () { syncArrows(row, track); }, { passive: true });

    row.appendChild(prev);
    row.appendChild(track);
    row.appendChild(next);

    wrap.innerHTML = '';
    wrap.appendChild(row);

    /* Chantelle asked on 1 Oct 2026 for the swatches to be hidden on the product page, leaving
       only the link through to the picker. Jordianne flagged it as her call rather than a
       recommendation, and it is.

       The row is hidden rather than dropped. The anchors are the links Google follows from one
       colour to the next - the MONICA page carries about 70 of them - and building the row and
       then hiding it keeps every one of those while showing the customer only the link, which is
       what was asked for. Deleting them would have cost the colour pages their way in. */
    // Only where the picker link replaces it. On a style with no picker page - BLACK WIDOW,
    // IZZY - hiding the row would leave the customer nothing at all to pick a colour from, which
    // is not what was asked for and is worse than either option.
    if (HIDE_ON_PDP && PICKER_STYLES.indexOf(style) > -1) {
      row.setAttribute('hidden', '');
      row.style.display = 'none';
      /* With the swatches and the labels gone the CTA is the only thing left in this block, and
         the theme's spacing around it was built for a 620px grid of thumbnails. The class lets
         the stylesheet close that gap up for these two styles alone - Chantelle, 14 Oct 2026:
         "can we make the margins a little tighter? the elements look quite far apart". */
      wrap.classList.add('cro-pdp--linkonly');
      hideColourLabels();
    }

    // The caption, and on MONICA and JUDE the way into the picker page. Same rule as the
    // collection cards: only styles the picker actually holds get a link.
    /* Chantelle, 14 Oct 2026: "can we put a cta to it? not just 69 colours? DISCOVER # COLOURS".

       Only where the caption is actually a link. On a style with no picker page it goes nowhere,
       and "DISCOVER" on something that cannot be clicked reads worse than the plain count. */
    var count;
    if (PICKER_STYLES.indexOf(style) > -1) {
      count = document.createElement('a');
      count.setAttribute('href', PICKER_URL);
      count.setAttribute('aria-label', 'Discover all ' + items.length + ' ' + style + ' colours');
      count.className = 'cro-sw__count cro-sw__count--cta';
      var ctaText = document.createElement('span');
      ctaText.textContent = 'DISCOVER ' + items.length + ' COLOURS';
      count.appendChild(ctaText);
      count.insertAdjacentHTML('beforeend', CHEVRON);
    } else {
      count = document.createElement('span');
      count.className = 'cro-sw__count';
      count.textContent = items.length + (items.length === 1 ? ' colour' : ' colours');
    }
    wrap.appendChild(count);

    // Start on the colour being viewed, so it is not scrolled off to the left.
    var current = track.querySelector('.p_data_item.active');
    if (current && current.offsetLeft > track.clientWidth - 40) {
      track.scrollLeft = Math.max(0, current.offsetLeft - track.clientWidth / 2);
    }
    syncArrows(row, track);
    if (window.ResizeObserver) new ResizeObserver(function () { syncArrows(row, track); }).observe(row);
  }

  ready(function () {
    var wrap = document.querySelector('.attribute-product');
    if (!wrap || wrap.getAttribute('data-cro-pdp') === '1') { done(); return; }
    var style = styleFrom(wrap);
    if (!style) { done(); return; }
    wrap.setAttribute('data-cro-pdp', '1');

    // The bundled file is read alongside the live one purely to fill gaps: some products have no
    // Shopify colour swatch, and without this MONICA (white) falls back to a close-up of its
    // photo and shows up grey.
    var src = (document.getElementById('cro-pdp-colours-data') || {}).dataset;
    HIDE_ON_PDP = !!(src && src.hide === '1');
    var bundled = (src && src.src)
      ? fetch(src.src).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
      : Promise.resolve(null);

    Promise.all([fetchStyle(style), bundled]).then(function (res) {
      var items = res[0];
      var file = res[1];
      var known = {};
      if (file && file.styles && file.styles[style]) {
        file.styles[style].forEach(function (o) { known[o.h] = o; });
      }
      var byHandle = {};
      (items || []).forEach(function (it) {
        var was = known[it.h];
        if ((!it.c || !it.c.length) && was && was.c && was.c.length) it.c = was.c;
        byHandle[it.h] = it;
      });
      // Deliberately not the other way round: a colour that is only in the bundled file is one
      // the storefront will not return, so it is either unpublished or unlisted. Adding it back
      // put monica-headband-lime - which answers 404 - into the row.
      // Even with no colour data the row is still worth building - the thumbnails become photo
      // swatches and the 620px block collapses to one line.
      build(wrap, byHandle, style);
      done();
    }).catch(function () { done(); /* leave the theme's own grid alone */ });
  });
})();
